import m from "../../@babel/runtime/helpers/esm/typeof2.mjs";
import h from "./warning.mjs";
function b(s, c) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, a = /* @__PURE__ */ new Set();
  function n(r, t) {
    var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, i = a.has(r);
    if (h(!i, "Warning: There may be circular references"), i)
      return !1;
    if (r === t)
      return !0;
    if (l && u > 1)
      return !1;
    a.add(r);
    var f = u + 1;
    if (Array.isArray(r)) {
      if (!Array.isArray(t) || r.length !== t.length)
        return !1;
      for (var e = 0; e < r.length; e++)
        if (!n(r[e], t[e], f))
          return !1;
      return !0;
    }
    if (r && t && m(r) === "object" && m(t) === "object") {
      var g = Object.keys(r);
      return g.length !== Object.keys(t).length ? !1 : g.every(function(o) {
        return n(r[o], t[o], f);
      });
    }
    return !1;
  }
  return n(s, c);
}
export {
  b as default
};
//# sourceMappingURL=isEqual.mjs.map
